import { useRef, useEffect } from 'react'
import type { RefObject } from 'react'

export const useInMemoryRestoreScroll = (
  key: string,
): RefObject<HTMLDivElement> => {
  const scrollPositions = useRef<Map<string, number>>(new Map())
  const scrollableEl = useRef<HTMLDivElement>(null)
  useEffect(() => {
    scrollableEl.current?.scrollTo({
      top: scrollPositions.current.get(key) ?? 0,
      behavior: 'smooth',
    })
    const interval = setInterval(() => {
      if (scrollableEl.current) {
        scrollPositions.current.set(key, scrollableEl.current.scrollTop)
      }
    }, 500)
    return () => clearInterval(interval)
  }, [key])

  return scrollableEl
}
